import { Stack } from "@mantine/core";
import { forwardRef } from "react";

import { AuthorBadge } from "./AuthorBadge";
import classes from "./message-component-styles.module.css";
import { MessageBubble } from "./MessageBubble";
import { TypingEllipsis } from "./TypingEllipsis";

interface CustomerTypingIndicatorProps {
    sessionId: string;
    customerName?: string;
    isLastCustomerMessage: boolean;
}

export const CustomerTypingIndicator = forwardRef<HTMLDivElement, CustomerTypingIndicatorProps>(
    function CustomerTypingIndicator({ sessionId, customerName, isLastCustomerMessage }, ref) {
        return (
            <Stack align="flexAlign" justify="flexAlign" mb="lg" gap="xs" ref={ref}>
                {!isLastCustomerMessage && ( //TODO: make sure this logic is correct
                    <AuthorBadge
                        senderType="customer"
                        senderId="customer"
                        customerName={customerName ?? "Customer"}
                        sessionId={sessionId}
                        dateCreated={null} // No date for typing indicator
                    />
                )}
                <MessageBubble lastOfGroup={true} senderType="customer" flexAlign="flex-start" maw="80%" p="md">
                    <span className={classes.customer_typing_indicator}>
                        {"Customer is typing "}
                        <TypingEllipsis />
                    </span>
                </MessageBubble>
            </Stack>
        );
    },
);
